import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
};

const followReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_FOLLOW_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.POST_FOLLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true
            };
        case types.POST_FOLLOW_FAILURE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};

export default followReducer;
